module.exports = __webpack_public_path__ + "static/media/KICTruck.3de4f0dc.png";